export default __webpack_public_path__ + "static/media/refugeoftheapostate.365c6468.jpg";